var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1597_196345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5422 7.04121C15.0714 7.55331 15.0852 8.39741 14.5731 8.92658L9.01883 14.666H25.8731C26.6094 14.666 27.2064 15.263 27.2064 15.9994C27.2064 16.7357 26.6094 17.3327 25.8731 17.3327H9.01883L14.5731 23.0721C15.0852 23.6013 15.0714 24.4454 14.5422 24.9575C14.0131 25.4696 13.1689 25.4557 12.6569 24.9266L5.36358 17.3902C4.61318 16.6148 4.61318 15.3839 5.36358 14.6085L12.6569 7.07212C13.1689 6.54296 14.0131 6.52912 14.5422 7.04121Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1597_196345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeftArrow);
export default __webpack_public_path__ + "static/media/ic_left-arrow.ed651ec7e8caa478578f0d07511ecfb8.svg";
export { ForwardRef as ReactComponent };